<form [formGroup]="form()">
  <fino-input formControlName="name" label="name" validationIndicator> </fino-input>

  <fino-input formControlName="iban" label="iban" validationIndicator> </fino-input>

  <fino-input formControlName="bic" [disabled]="hasIban" label="bic" validationIndicator>
  </fino-input>

  <fino-input formControlName="amount" label="amount" validationIndicator> </fino-input>

  <fino-select
    [items]="currencyCodesItems"
    formControlName="currency"
    label="currency"
    [searchable]="true"
    bindLabel="label"
    bindValue="value"
  >
    <div *select-item="let item">
      <div>{{ item.label }}</div>
    </div>
  </fino-select>

  <fino-select
    [items]="intervalTypeItems"
    formControlName="interval"
    label="interval"
    #intervalSelect
    bindLabel="label"
    bindValue="value"
  >
    <div *select-item="let item">
      <div>{{ item.value | translate }}</div>
    </div>
  </fino-select>

  @if (!isTerminueberweisung()) {
    <fino-select
      [items]="executionDayItems"
      formControlName="executionDay"
      #executionDaySelect
      label="executionDay"
      [searchable]="true"
      bindLabel="value"
      bindValue="value"
    >
      <div *select-item="let item">
        <div>{{ item.value }}</div>
      </div>
    </fino-select>
  }

  @if (!isTerminueberweisung()) {
    <fino-input formControlName="firstExecution" label="firstExecutionDay" validationIndicator>
    </fino-input>
  }

  <fino-input formControlName="nextExecution" label="nextExecutionDay" validationIndicator>
  </fino-input>

  @if (!isTerminueberweisung()) {
    <fino-input formControlName="lastExecution" label="lastExecutionDay" validationIndicator>
    </fino-input>
  }

  <fino-textarea formControlName="purpose" label="purpose"> </fino-textarea>

  <fino-textarea formControlName="comment" label="comment"> </fino-textarea>

  <button
    type="submit"
    fino-button
    (click)="submit()"
    [disabled]="!(isFormValid || hasComment)"
    [primary]="true"
    class="mb-3"
  >
    @if (isUpdateMode()) {
      <span translate="standingOrders.update"></span>
    }
    @if (!isUpdateMode()) {
      <span translate="standingOrders.add"></span>
    }
  </button>

  @if (hasStandingOrders()) {
    <div class="columns" [formGroup]="searchForm">
      <div class="column is-8">
        <fino-input formControlName="search" class="mr-2" label="Suchen"> </fino-input>
      </div>
      <div class="column">
        <button class="mt-1 is-fullwidth" fino-button (click)="deleteAllItems()">
          <span class="mr-1">{{ 'standingOrders.all' | translate }}</span>
          <fino-icon icon="Bin 1"></fino-icon>
        </button>
      </div>
    </div>
  }

  @if (hasStandingOrders()) {
    <div class="items-container">
      @for (standingOrder of filteredStandingOrders(); track standingOrder) {
        <article [class.is-primary]="standingOrder.selected" class="panel">
          <div class="panel-heading">
            <div class="columns">
              <div class="column">
                <p class="has-text-white">{{ standingOrder.name }}</p>
              </div>
              <div class="column is-flex is-justify-content-flex-end">
                <fino-icon
                  icon="Pencil 2"
                  (click)="editItem(standingOrder)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Common File Double"
                  (click)="duplicateItem(standingOrder)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Bin 1"
                  (click)="deleteItem(standingOrder, !standingOrder.selected)"
                  class="has-text-white"
                ></fino-icon>
              </div>
            </div>
          </div>
          <div
            class="panel-block is-flex is-flex-direction-column is-align-items-flex-start"
            [class.has-text-grey-light]="!standingOrder.selected"
          >
            @if (standingOrder.name) {
              <label
                ><span translate="standingOrders.name"></span>
                <b>{{ standingOrder.name }}</b>
              </label>
            }
            @if (standingOrder.iban) {
              <label
                ><span translate="standingOrders.iban"></span>
                <b>{{ standingOrder.iban | iban }}</b>
              </label>
            }
            @if (standingOrder.amount && standingOrder.currency) {
              <label
                ><span translate="standingOrders.amount"></span>
                <b>{{ standingOrder.amount }} {{ standingOrder.currency }}</b>
              </label>
            }
            @if (standingOrder.interval) {
              <label
                ><span translate="standingOrders.zyklus"></span
                ><b>{{ standingOrder.interval | translate }}</b></label
              >
            }
            @if (standingOrder.nextExecution) {
              <label
                ><span translate="standingOrders.nextExecution"></span>
                <b>{{ transformToDate(standingOrder.nextExecution) | date }}</b></label
              >
            }
            @if (standingOrder.executionDay) {
              <label
                ><span translate="standingOrders.executionDay"></span>
                <b>{{ standingOrder.executionDay }}</b></label
              >
            }
            @if (standingOrder.comment) {
              <label
                ><span translate="standingOrders.comment"></span
                ><b>{{ standingOrder.comment }}</b></label
              >
            }
          </div>
        </article>
      }
    </div>
  }
</form>
